import { render, staticRenderFns } from "./WineProduction.vue?vue&type=template&id=edb3d702&scoped=true&"
import script from "./WineProduction.vue?vue&type=script&lang=js&"
export * from "./WineProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb3d702",
  null
  
)

export default component.exports